module.exports = {
	hooks: {
		attach: function($element, options){
			// console.log('cat filter attach');
		}
	}
};